<div (click)="window.innerWidth <= mobileMaxWidth ? openDatePickerModal() : menuTrigger.openMenu()">
  <div #contentSlot>
    <ng-content></ng-content>
  </div>

  @if (!contentSlot.children.length) {
    <lla-selector-card
      label="Select Period"
      [value]="displayPeriodValue"
      [extraClasses]="extraClasses"
    ></lla-selector-card>
  }
</div>

<div
  [matMenuTriggerFor]="dateRangePickerMenu"
  #menuTrigger="matMenuTrigger"
  (menuOpened)="onMenuOpened()"
  (menuClosed)="setSelectedDate(); menuIsOpen = false"
></div>

<mat-menu
  #dateRangePickerMenu="matMenu"
  [hasBackdrop]="true"
  backdropClass="mg-menu-backdrop"
  class="lla-filter-menu-full"
>
  <div
    class="flex-1 flex flex-col overflow-auto w-full md:w-[442px] bg-contrast border border-ui-separator"
    (click)="$event.stopPropagation()"
    (keydown.Tab)="$event.stopPropagation()"
  >
    @if (menuIsOpen) {
      <lla-range-date-picker
        focusInput="start"
        [value]="selectedValue"
        [maxDate]="maxDate"
        [minDate]="minDate"
        [hideAllPeriods]="hideAllPeriods"
        [hiddenPeriods]="hiddenPeriods"
        [showMoonLanding]="showMoonLanding"
        [enableRangePickerType]="enableRangePickerType"
        [rangePickerType]="rangePickerType"
        (valueChanged)="valueChanged.emit($event); saveRangePickerType(); menuTrigger.closeMenu()"
        (canceld)="menuTrigger.closeMenu()"
        (rangePickerTypeChange)="onRangePickerTypeChange($event)"
      ></lla-range-date-picker>
    }
  </div>
</mat-menu>
